import "../../components/global.js";
import "../../assets/css/bootstrap.css";
import Navbar from "../../components/Navbar";
import Select from "react-select";
import { loading, tokens, select_style, alert, alert_url, toFixed, GET, POST, PUT, format_date, float, DatePicker, getStorage, calculate_water, cal_water_bill } from "../../components/CustomComponent.js";
import React, { Component } from "react";

const r_det = getStorage("role_detail")?.find(i => i.name === "record-water-usage")?.role || [];
const view_r = r_det[0] === 1, create_r = r_det[1] === 1;

export default class RecordWaterUsage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      update: false, data_address: null, data_fullname: [],
      record_water_id: "", last_gauge_number: 0, current_gauge_number: 0, unit_used: 0, water_bill: 0,
      address_number: "", equipment_maintenance_fee: 0, common_expenses: 0, common_expenses_type: false,
      penalty_day_list: [], penalty_month_list: [], waste_cost: 0, cable_cost: 0, other_income: 0,
      add_debt: 0, reduce_debt: 0, fire_month: "", fire_cost: 0, remark_add_debt: "", remark_reduce_debt: "",
      total_amount: 0, status_cable: false, full_name: "", room_size: 0, status_meter: 0, date_of_note: new Date(),
      setting_water_id: getStorage("water_id"), water_charge_start: 0, water_charge_end: 0, water_charge_price: 0,
      water_rate_list: [], payment_deadline: 0, common_expenses_text: 0, max_date: null
    };
  }

  async componentDidMount() {
    // โหลดอัตราค่าน้ำให้เข้า state ก่อน แล้วค่อยเปิดบิล — กัน cal_water(0) ได้ 0 เพราะ settings ยังไม่มา
    if (view_r) {
      await this.GetSetting();
      await this.GetAddressNumberAll();
    }
  }

  getTotal = (s = this.state) => ["water_bill", "equipment_maintenance_fee", "common_expenses", "waste_cost", "other_income", "add_debt", "fire_cost"]
    .reduce((sum, k) => sum + Number(s[k] || 0), 0) + (s.status_cable ? Number(s.cable_cost || 0) : 0) - Number(s.reduce_debt || 0);

  pid = () => getStorage("project_id");

  // afterSave = true: เรียกหลังบันทึกสำเร็จ — ถ้าบันทึกครบทุกบ้านแล้วให้แจ้งสำเร็จ แทนคำเตือน "ไม่มีข้อมูลบ้านเลขที่ในเดือนนี้"
  GetAddressNumberAll = async (afterSave = false) => {
    let r = await GET(tokens, `v1/TH/record-water/address-list/${this.pid()}`, { now_month: Number(format_date(this.state.date_of_note, "mm")), now_year: Number(format_date(this.state.date_of_note, "yyyy", "en")) });
    if (r?.status) {
      let d = r.data.data.sort((a, b) => a.address_number.localeCompare(b.address_number, undefined, { numeric: true }));
      this.setState({ data_address: d });
      if (this.props.location.query.id) {
        this.setState({ update: true, record_water_id: this.props.location.query.id }, () => this.GetById(this.props.location.query.id));
      } else if (!d.length) {
        if (afterSave === true) alert("success", "บันทึกข้อมูลสำเร็จ", "บันทึกข้อมูลครบทุกบ้านเลขที่ในเดือนนี้แล้ว");
        else alert("warning", "แจ้งเตือน", "ไม่มีข้อมูลบ้านเลขที่ในเดือนนี้");
      } else {
        this.setState({ address_number: { value: d[0].address_number, label: d[0].address_number } }, this.GetAddressById);
      }
    }
  };

  GetAddressById = async () => {
    let r = await GET(tokens, `v1/TH/record-water/address-number/detail/${this.pid()}`, { address_number: this.state.address_number?.value || "", date_of_note: format_date(this.state.date_of_note || new Date(), "yyyy-mm-dd", "en") });
    if (r?.status) {
      let d = r.data.data;
      this.setState({
        room_size: d.room_size, last_gauge_number: d.last_gauge_number, current_gauge_number: d.last_gauge_number,
        cable_cost: d.cable_cost, equipment_maintenance_fee: d.equipment_maintenance_fee, waste_cost: d.waste_cost,
        common_expenses: this.state.common_expenses_type ? d.common_expenses * d.room_size : d.common_expenses,
        unit_used: 0, water_bill: Number(this.state.water_charge_price), status_cable: d.status_cable, full_name: d.full_name,
        status_meter: d.status_meter === 0 ? { value: 0, label: "" } : d.status_meter === 1 ? { value: 1, label: "ปกติ" } : { value: 2, label: "ตัดมิเตอร์" },
      });
    }
    setTimeout(() => document.getElementById("current_gauge_number")?.focus(), 100);
  };

  GetById = async (id) => {
    loading(true);
    let r = await GET(tokens, `v1/TH/record-water/detail/${id}`, null);
    if (r?.status) {
      let d = r.data.data;
      this.setState({
        data_address: [...(this.state.data_address || []), { value: d.address_number, label: d.address_number }],
        record_water_id: d.record_water_id, last_gauge_number: d.last_gauge_number, current_gauge_number: d.current_gauge_number,
        unit_used: d.unit_used, water_bill: d.water_bill, address_number: { value: d.address_number, label: d.address_number },
        equipment_maintenance_fee: d.equipment_maintenance_fee, common_expenses: d.common_expenses, waste_cost: d.waste_cost,
        cable_cost: d.cable_cost, status_cable: d.cable_cost !== 0, other_income: d.other_income, add_debt: d.add_debt,
        reduce_debt: d.reduce_debt, fire_cost: d.fire_cost, remark_add_debt: d.remark_add_debt, remark_reduce_debt: d.remark_reduce_debt,
        total_amount: d.total_amount, full_name: d.full_name, room_size: d.room_size, date_of_note: d.datetime_create,
        status_meter: d.status_meter === 0 ? { value: 0, label: "" } : d.status_meter === 1 ? { value: 1, label: "ปกติ" } : { value: 2, label: "ตัดมิเตอร์" },
        max_date: this.props.location.query.id ? format_date(new Date(new Date(d.datetime_create).setDate(this.state.payment_deadline)), "yyyy-mm-dd", "en") : this.state.max_date
      }, () => {
         loading(false);
        this.setState({ water_bill: this.cal_water(d.unit_used) });
      });
    }
  };

  GetSetting = async () => {
    loading(true);
    let r = await GET(tokens, `v1/TH/water-manage/detail/${this.state.setting_water_id}`, null);
    if (r?.status) {
      let d = r.data.data, date_of_note = new Date();
      if (d.payment_deadline) {
        let now = new Date();
        now.setDate(Number(d.payment_deadline));
        if (new Date() < now) now.setMonth(now.getMonth() - 1);
        date_of_note = now;
      }
      await new Promise((resolve) => {
        this.setState({
          water_charge_start: Number(d.water_charge.water_charge_start), water_charge_end: Number(d.water_charge.water_charge_end),
          water_charge_price: Number(d.water_charge.water_charge_price), water_rate_list: d.water_rate_list, water_calculate_type: Number(d.water_calculate_type) || 2,
          add_debt: Number(d.add_debt), reduce_debt: Number(d.reduce_debt), fire_month: d.fire_month,
          fire_cost: (d.fire_month && format_date(new Date(), "m") === d.fire_month) ? Number(d.fire_cost) : 0,
          common_expenses_type: d.common_expenses_type, common_expenses_text: d.common_expenses, payment_deadline: d.payment_deadline,
          penalty_day_list: d.penalty_day_list, penalty_month_list: d.penalty_month_list, meter_cut_month: d.meter_cut_month,
          meter_cut_date: d.meter_cut_date, meter_convergence: d.meter_convergence, date_of_note
        }, resolve);
      });
      loading(false);
      if (!d.payment_close_time || !d.meter_cut_date || !d.penalty_day_list.length || !d.penalty_month_list.length) {
        alert_url("warning", "แจ้งเตือน", "ท่านยังไม่ทำการตั้งค่าอัตราค่าน้ำก่อนทำการเริ่มต้นใช้งานระบบ", "/manage-water");
      }
    } else {
      loading(false);
    }
  };

  cal_water = (unitStr) => cal_water_bill(unitStr, this.state);

  processSave = async (isUpdate) => {
    if (Number(this.state.unit_used) < 0) return alert("warning", "แจ้งเตือน", "ไม่สามารถกรอกเลขมาตรในเดือนนี้น้อยกว่าเดือนก่อนได้");
    loading(true);

    let dt = format_date(this.state.date_of_note, "yyyy-mm-dd hh:mm", "en");
    let data = {
      ...this.state, address_number: this.state.address_number?.label || "",
      status_meter: this.state.status_meter?.value || 0,
      cable_cost: this.state.status_cable ? Number(this.state.cable_cost) : 0,
      total_amount: this.getTotal(), datetime_create: isUpdate ? this.state.date_of_note : dt
    };
    if (!isUpdate) data.date_of_note = dt;

    let r = isUpdate ? await PUT(tokens, `v1/TH/record-water/create/${this.pid()}`, data) : await POST(tokens, `v1/TH/record-water/create/${this.pid()}`, data);
    if (r?.status) {
      if (isUpdate && this.props.location.query.id) {
        calculate_water(this.state.address_number?.label || "")
        alert_url("success", "บันทึกข้อมูลสำเร็จ", "ข้อมูลได้ถูกบันทึกเรียบร้อยแล้ว", "/water-usage-info");
      }
      else {
        setTimeout(() => this.GetAddressNumberAll(true), 1);
      }
      this.setState({ last_gauge_number: 0, current_gauge_number: 0, unit_used: 0, water_bill: 0, address_number: "", equipment_maintenance_fee: 0, common_expenses: 0, waste_cost: 0, cable_cost: 0, other_income: 0, add_debt: 0, reduce_debt: 0, remark_add_debt: "", remark_reduce_debt: "", total_amount: 0, full_name: "", room_size: 0, status_meter: 0 });
      
    }
    loading(false);
  };

  hk = (nxt) => (e) => e.key === "Enter" && nxt && (nxt === "SUBMIT" ? this.processSave(this.state.update) : document.getElementById(nxt)?.focus());

  inp = (lbl, id, k, nxt = null, extra = null) => (
    <div className="col-12 col-md-6 col-lg-3 mb-2">
      <label>{lbl} {extra}</label>
      <input type="text" id={id} className="form-control bg-contain border-0 mx-1 mb-2" placeholder="กรอกข้อมูล" value={this.state[k]} disabled={!nxt && id !== "remark_add_debt" && id !== "remark_reduce_debt"}
        onChange={(e) => float(e.target.value) && this.setState({ [k]: e.target.value || 0 })} onKeyUp={nxt ? this.hk(nxt) : undefined} />
    </div>
  );

  render() {
    const s = this.state;
    return (
      <div className="w-100 min-vh-100 fade-in">
        {s.loading && <div className="spinner-container"><div className="loading-spinner"></div></div>}
        <Navbar page1="หน้าหลัก" page2="บันทึกค่าใช้จ่าย" />
        <div className="body">
          <div className="p-3">
            <div className="w-100">
              {view_r && (
                <div className="d-flex row mx-0 align-items-center justify-content-between">
                  <h4 className="mb-3"><b>บันทึกค่าใช้จ่าย เดือน{format_date(new Date(), "mmmm")} พ.ศ. {format_date(new Date(), "yyyy")}</b></h4>
                  <button className="btn btn-outline-primary px-4 mx-1 mb-3" onClick={() => window.location.href = "/water-usage-info"}>รายการทั้งหมด</button>
                </div>
              )}
              <div className="card border-0 p-3 mb-3">
                <div className="row mx-0">
                  <div className="col-12 col-md-6 col-lg-3 mb-2">
                    <label>บ้านเลขที่</label>
                    <Select className="form-control bg-contain border-0 w-100 select-search" styles={select_style} options={s.data_address?.map(i => ({ value: i.address_number, label: i.address_number, ...i })) || []} onChange={(e) => this.setState({ address_number: e }, this.GetAddressById)} value={s.address_number} />
                  </div>
                  {this.inp("ชื่อ-นามสกุล", "full_name", "full_name")}
                  <div className="col-12 col-md-6 col-lg-3 mb-2"><label>ขนาดห้อง (ตรม.)</label><input type="text" className="form-control bg-contain border-0 mx-1 mb-2" value={toFixed(s.room_size)} disabled /></div>
                  <div className="col-12 col-md-6 col-lg-3 mb-2"><label>สถานะมิเตอร์น้ำ</label><Select className="form-control bg-contain border-0 w-100 select-search" styles={select_style} options={[{ value: 0, label: "" }, { value: 1, label: "ปกติ" }, { value: 2, label: "ตัดมิเตอร์" }]} value={s.status_meter} isDisabled={true} /></div>
                  <div className="col-12 col-md-6 col-lg-3 mb-2">
                    <label>วันที่จด</label>
                    <DatePicker className="form-control bg-contain border-0 w-100" value={s.date_of_note} min={s.max_date ? format_date(new Date(new Date(s.max_date).setDate(new Date(s.max_date).getDate() - 1)), "yyyy-mm-dd", "en") : null} max={s.max_date || null} onChange={(e) => this.setState({ date_of_note: e }, () => !this.props.location.query.id && this.GetAddressNumberAll())} />
                  </div>
                  <div className="col-12 col-md-6 col-lg-3 mb-2">
                    <label>เลขมาตรเดือนก่อน</label>
                    <input type="text" id="last_gauge_number" className="form-control bg-contain border-0 mx-1 mb-2" value={s.last_gauge_number} onKeyUp={this.hk("current_gauge_number")}
                      onChange={(e) => float(e.target.value) && this.setState({ unit_used: Number(s.current_gauge_number) - Number(e.target.value), last_gauge_number: Number(e.target.value) }, () => this.setState({ water_bill: this.cal_water(this.state.unit_used) }))} />
                  </div>
                  <div className="col-12 col-md-6 col-lg-3 mb-2">
                    <label>เลขมาตรเดือนนี้</label>
                    <input type="text" id="current_gauge_number" className="form-control bg-contain border-0 mx-1 mb-2" value={s.current_gauge_number} onKeyUp={this.hk("other_income")}
                      onChange={(e) => float(e.target.value) && this.setState({ unit_used: Number(e.target.value) - Number(s.last_gauge_number), current_gauge_number: Number(e.target.value) }, () => this.setState({ water_bill: this.cal_water(this.state.unit_used) }))} />
                  </div>
                  {this.inp("จำนวนหน่วยที่ใช้", "unit_used", "unit_used")}
                </div>
              </div>
              <div className="card border-0 p-3 mb-3">
                <div className="row mx-0">
                  {this.inp("ค่าน้ำประปา", "water_bill", "water_bill", "equipment_maintenance_fee")}
                  {this.inp("ค่ารักษาอุปกรณ์", "equipment_maintenance_fee", "equipment_maintenance_fee", "common_expenses")}
                  {this.inp(`ค่าส่วนกลาง ${s.common_expenses_type ? "( " + toFixed(s.common_expenses_text) + " บาท/ตรม. )" : ""}`, "common_expenses", "common_expenses", "waste_cost")}
                  {this.inp("ค่าขยะ", "waste_cost", "waste_cost", "cable_cost")}
                  {this.inp("ค่าเคเบิล", "cable_cost", "cable_cost", "fire_cost", s.cable_cost !== 0 && <input className="ml-2" type="checkbox" onChange={(e) => this.setState({ status_cable: e.target.checked })} checked={s.status_cable} />)}
                  {this.inp("ค่าเบี้ยประกัน", "fire_cost", "fire_cost", "other_income")}
                  {this.inp("รายได้อื่น", "other_income", "other_income", "add_debt")}
                  {this.inp("เพิ่มหนี้", "add_debt", "add_debt", "remark_add_debt")}
                  <div className="col-12 col-md-6 col-lg-3 mb-2"><label>หมายเหตุเพิ่มหนี้</label><input type="text" id="remark_add_debt" className="form-control bg-contain border-0 mx-1 mb-2" placeholder="กรอกข้อมูล" onChange={(e) => this.setState({ remark_add_debt: e.target.value })} onKeyUp={this.hk("reduce_debt")} value={s.remark_add_debt} /></div>
                  {this.inp("ลดหนี้", "reduce_debt", "reduce_debt", "remark_reduce_debt")}
                  <div className="col-12 col-md-6 col-lg-3 mb-2"><label>หมายเหตุลดหนี้</label><input type="text" id="remark_reduce_debt" className="form-control bg-contain border-0 mx-1 mb-2" placeholder="กรอกข้อมูล" onChange={(e) => this.setState({ remark_reduce_debt: e.target.value })} onKeyUp={this.hk("SUBMIT")} value={s.remark_reduce_debt} /></div>
                </div>
                <div className="d-flex align-items-end justify-content-between">
                  <div><label>รวมเป็นเงิน</label><h4><b>฿{toFixed(this.getTotal())}</b></h4></div>
                  {create_r && <button className="btn btn-primary px-5" onClick={() => this.processSave(s.update)}>{s.update ? "บันทึกการแก้ไข" : "เพิ่มข้อมูล"}</button>}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}